import { Form } from './form';
import { Config } from '../config';
import { StripeValidator } from '../validators/stripe-validator';
import { StripeBacsView } from '../view/stripe-bacs-view';
import { FormTypes } from './form-types';
import { Logger } from '../logger';
import { Order } from '../config/order';
import { PaymentType } from '../providers/payment-type';

declare const Stripe: any;

export class StripeBacsForm extends Form {

    private stripeAPI: any;
    private elements: any;
    private stripeElement: any;
    logger: Logger = {} as Logger;
    view: StripeBacsView = new StripeBacsView();
    type = FormTypes.Stripe_Bacs;
    isNoTotal = false;
    requiresMandateConfirmation = false;
    paymentIntentId = '';

    constructor(step: number | null = null) {
        super();
        this.step = step;
    }

    async init(config: Config, callback: any) {
        await super.init(config, callback);
        return this.loadScript('https://js.stripe.com/v3/')
            .then(() => this.validators.push(new StripeValidator()));
    }

    render() {
        if (!this.isNoPayment) {
            this.view.renderStripeFormFragment();
            this.view.hideStripeElementsContainer();
            this.stripeAPI = Stripe(this.config.forms.stripe.stripeKey);
            setTimeout(() => {
                this.view.applyHubspotCss();
            }, 500);
        }

        if (this.step) {
            this.hideForm();
        }

        return Promise.resolve();
    }

    showMandateConfirmation(config: any, response: any) {
        if (this.stripeElement) {
            this.stripeElement.unmount();
        }
        this.requiresMandateConfirmation = true;
        this.paymentIntentId = response.stripe.paymentIntentId;

        this.elements = this.stripeAPI.elements({
            clientSecret: response.stripe.paymentIntentClientSecret
        });
        this.stripeElement = this.elements.create('payment');
        this.stripeElement.mount('#stripe_bacs_elements');

        this.stripeElement.on('ready', () => {
            this.view.removeDefaultBacsElementsStyle();
            this.view.showStripeElementsContainer();
            this.view.showStripeBacsFormBlock();
            this.view.showPayNowButton();
            this.config.widget.view.stopProgress();
        });
    }

    unmount() {
        this.stripeElement.unmount();
    }

    async submit(order: Order) {
        const contact = order.params[0];
        order.paymentMethod = {
            type: PaymentType.STRIPE_BACS,
            stripeEmail: contact.email,
            paymentIntentId: this.paymentIntentId,
            accountId: this.config.forms.stripe.accountId ? this.config.forms.stripe.accountId : null
        };

        if (!this.requiresMandateConfirmation) {
            return Promise.resolve(order);
        }

        const elements = this.elements;
        return this.stripeAPI.confirmPayment({
            elements,
            redirect: 'if_required'
        })
        .then((response: any) => {
            this.view.hideError('#stripe_bacs_error');
            if (response.error) {
                this.view.showError(response.error.message, '#stripe_bacs_error');
                this.logger = new Logger(this.config);
                this.logger.log(response.error.message);
                return Promise.reject(response.error.message);
            }
            order.paymentMethod.paymentMethodId = response.paymentIntent.payment_method;
            this.requiresMandateConfirmation = false;
            return Promise.resolve(order);
        });

    }

    postSubmit(submissionContext: any): Promise<any> {
        this.config.widget.triggerAppEvent('onFormSubmitted', submissionContext);
        this.config.widget.redirectOrMessage();
        return Promise.resolve();
    }

    upSellSubmit(upsellResponse: any): Promise<any> {
        this.config.widget.renderUpSell();
        return Promise.resolve();
    }


    showPaymentFields() {
        this.view.showStripeBacsForm();
    }

    hidePaymentFields() {
        this.view.hideStripeBacsForm();
    }

    showForm() {
        this.view.showForm();
    }

    hideForm() {
        this.view.hideForm();
    }

}
